import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onMounted } from 'vue';
import { backendApi, AxiosError } from '@/http';
import { FilterType } from '@/composables/datatable';
import { $t } from '@/i18n';

interface Props {
  endPoint: string;
  modelValue: string | number | null | string[] | number[];
  titleKey: string;
  valueKey: string;
  variant?:
    | 'outlined'
    | 'plain'
    | 'filled'
    | 'underlined'
    | 'solo'
    | 'solo-inverted'
    | 'solo-filled';
  density?: 'default' | 'comfortable' | 'compact' | null;
  suffix?: string;
  hint?: string;
  persistentHint?: boolean;
  filterKey?: string | null;
  filterValue?: string | number | boolean | null;
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'PeripheralsSelect',
  props: {
    endPoint: {},
    modelValue: {},
    titleKey: {},
    valueKey: {},
    variant: {},
    density: {},
    suffix: {},
    hint: {},
    persistentHint: { type: Boolean },
    filterKey: {},
    filterValue: { type: [String, Number, Boolean, null] }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: $emit }) {

const props = __props;



// eslint-disable-next-line no-undef


const itemsList = ref<Record<string, unknown>[]>([]);
const modelValue = ref(props.modelValue);
const isLoading = ref(false);
const errorMessage = ref(undefined);

const updateValue = (newValue: string | number | null) => {
  modelValue.value = newValue;
  $emit('update:modelValue', newValue);
};

async function getItems() {
  try {
    isLoading.value = true;
    errorMessage.value = undefined;

    const filters: FilterType[] = [];
    if (props.filterKey != null && props.filterValue != null) {
      filters.push({
        key: props.filterKey,
        operator: '=',
        value: props.filterValue,
      });
    }

    const result = await backendApi.get(props.endPoint, {
      params: {
        filter: filters,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    itemsList.value = result.data.data as Record<string, unknown>[];
  } catch (error: unknown) {
    errorMessage.value =
      error instanceof AxiosError && error.response?.data.message
        ? error.response.data.message
        : $t('FAILED_TO_LOAD_DATA');
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  getItems();
});

watch(
  () => props.modelValue,
  (newValue) => {
    modelValue.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    "model-value": modelValue.value,
    items: itemsList.value,
    loading: isLoading.value,
    "item-title": props.titleKey,
    "item-value": props.valueKey,
    variant: props.variant ?? 'filled',
    density: props.density ?? 'compact',
    suffix: props.suffix,
    hint: props.hint,
    "persistent-hint": props.persistentHint,
    "auto-select-first": true,
    "error-messages": errorMessage.value,
    "onUpdate:modelValue": updateValue
  }, null, 8, ["model-value", "items", "loading", "item-title", "item-value", "variant", "density", "suffix", "hint", "persistent-hint", "error-messages"]))
}
}

})